require 'angular'

angular.module('workflow.app')
  .controller('ResearchRequestModalController', require './ResearchRequestModalController')
  .controller 'ReceivedController', ($scope, $uibModalInstance, $stateParams) ->
    $scope.reference = $stateParams.workflowStepId

    $scope.cancel = ->
      $uibModalInstance.dismiss "cancel"
      return
